import { Pipe, PipeTransform } from '@angular/core';
import 'intl';
import 'intl/locale-data/jsonp/en.js';


@Pipe({
    name: 'currencyFormat'
})
export class CurrencyTransformPipe implements PipeTransform {


    /**
     * get currecny by store decimals
     * @param  {number} value
     * @returns number
     */
    getFormatedCurrency(value: number, store: any): number {
        // tslint:disable-next-line:no-bitwise
        return value ? Number(value.toFixed(Math.max(0, ~~store.numberDecimals))) : 0;
    }
    /**
     * @description get decimal formatted CurrencyCode
     * @author njagadeesan
     * @date 2020-11-20
     * @param {number} value
     * @param {*} store
     * @returns {string}
     * @memberof CurrencyTransformPipe
     */
    getDecimalFormattedCurrency(value: number, store: any): string {
        // tslint:disable-next-line: no-bitwise
        return value ? value.toFixed(Math.max(0, ~~store.numberDecimals)) : '0';
    }

    /**
     * @description to get Currency Format based on Store seperators 
     * @author Akhil
     * @date 2021-08-05
     * @param {number} value
     * @param {*} store
     * @returns {string}
     * @memberof CurrencyTransformPipe
     */
    getFormatedCurrencyWithSepartors(value: number | any, store: any): string|any {
        value = value || 0;
        if (store) {
            // const chunkLength = 3;
            // const num = value.toString();
            // const result: string = '\\d(?=(\\d{' + chunkLength + '})+' + (store.numberDecimals > 0 ? '\\D' : '$') + ')';
            // return (store.decimalSeparator ?
            //     num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
            //         store.thousandSeperator);
        let removeCurrencyCode: boolean = false;
        let removeCurrencySymbol: boolean = false;
        let removeSymbolAndCode: boolean = false;
        let priceOnly: boolean = false;
        const currencyValue = value || 0;
        if ((currencyValue || currencyValue==0) && store) {
            return this.getCurrencyFormat(store, store.currencyFormatCode, currencyValue, removeCurrencyCode,
                removeCurrencySymbol, removeSymbolAndCode, priceOnly);
        }
        }
        return value.toString();
    }

    getCurrencyFormat(store: any, format: string, value: number, removeCurrencyCode: boolean = false,
        removeCurrencySymbol: boolean = false, removeSymbolAndCode: boolean = false, priceOnly: boolean = false) {         
        const chunkLength = 3;
        value = +value || 0;
        const num = store.numberDecimals? value.toFixed(Math.max(0, ~~store.numberDecimals)):value.toFixed(2);
        const result: string = '\\d(?=(\\d{' + chunkLength + '})+' + (store.numberDecimals > 0 ? '\\D' : '$') + ')';
        let formattedCurrency = '';
        let currencyCode: string = removeCurrencyCode ? '' : store.currencyCode;
        let currencySymbol: string = removeCurrencySymbol ? '' : store.currencySymbol;
        if (removeSymbolAndCode) {
            currencyCode = '';
            currencySymbol = '';
        }
        if (priceOnly) {
            format = '';
        }
        switch (format) {
            case 'CL':
                formattedCurrency = currencyCode + ' ' + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:''));
                break;
            case 'CR':
                formattedCurrency = (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:'')) + ' ' + currencyCode;
                break;
            case 'SL':
                formattedCurrency = currencySymbol + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:''));
                break;
            case 'SR':
                formattedCurrency = (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:'')) + currencySymbol;
                break;
            case 'CRSL':
                formattedCurrency = currencySymbol + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:'')) + ' ' + currencyCode;
                break;
            case 'SRCL':
                formattedCurrency = currencyCode + ' ' + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:'')) + currencySymbol;
                break;
            default:
                formattedCurrency = currencySymbol + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator? store.thousandSeperator:''));
                break;
        }
        return formattedCurrency;
    }

    transform(value: number, store: any, removeCurrencyCode: boolean = false, removeCurrencySymbol: boolean = false,
        removeSymbolAndCode: boolean = false, priceOnly: boolean = false): string {
            const currencyValue = value || 0;
        if ((currencyValue || currencyValue==0) && store) {
            return this.getCurrencyFormat(store, store.currencyFormatCode, currencyValue, removeCurrencyCode,
                removeCurrencySymbol, removeSymbolAndCode, priceOnly);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/currency-format.pipe.ts